import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[documentTypesApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[documentTypesApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    // === Document Types ===
    async getDocumentTypes() {
        try {
            const response = await axiosInstance.get('document-types/');
            return response.data;
        } catch (error) {
            logAndRethrow('GET document-types/', error);
        }
    },

    async getDocumentType(id) {
        try {
            const response = await axiosInstance.get(`document-types/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET document-types/${id}/`, error);
        }
    },

    async createDocumentType(data) {
        try {
            const response = await axiosInstance.post('document-types/', data);
            console.log('[documentTypesApi] createDocumentType raw response:', response);
            console.log('[documentTypesApi] createDocumentType response.data:', response.data);
            console.log('[documentTypesApi] createDocumentType response.data keys:', Object.keys(response.data));
            return response.data;
        } catch (error) {
            logAndRethrow('POST document-types/', error);
        }
    },

    async updateDocumentType(id, data) {
        try {
            const response = await axiosInstance.patch(`document-types/${id}/`, data);
            return response.data;
        } catch (error) {
            logAndRethrow(`PATCH document-types/${id}/`, error);
        }
    },

    async deleteDocumentType(id) {
        try {
            const response = await axiosInstance.delete(`document-types/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`DELETE document-types/${id}/`, error);
        }
    },

    // === File Types ===
    async getFileTypes() {
        try {
            const response = await axiosInstance.get('file-types/');
            return response.data;
        } catch (error) {
            logAndRethrow('GET file-types/', error);
        }
    },

    async getFileType(id) {
        try {
            const response = await axiosInstance.get(`file-types/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET file-types/${id}/`, error);
        }
    },

    async createFileType(data) {
        try {
            const response = await axiosInstance.post('file-types/', data);
            console.log('[documentTypesApi] createFileType raw response:', response);
            console.log('[documentTypesApi] createFileType response.data:', response.data);
            console.log('[documentTypesApi] createFileType response.data keys:', Object.keys(response.data));
            return response.data;
        } catch (error) {
            logAndRethrow('POST file-types/', error);
        }
    },

    async updateFileType(id, data) {
        try {
            const response = await axiosInstance.patch(`file-types/${id}/`, data);
            return response.data;
        } catch (error) {
            logAndRethrow(`PATCH file-types/${id}/`, error);
        }
    },

    async deleteFileType(id) {
        try {
            const response = await axiosInstance.delete(`file-types/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`DELETE file-types/${id}/`, error);
        }
    },
};
